import { render, staticRenderFns } from "./JobOfferSettings.vue?vue&type=template&id=6b597410&scoped=true&"
import script from "./JobOfferSettings.vue?vue&type=script&lang=js&"
export * from "./JobOfferSettings.vue?vue&type=script&lang=js&"
import style0 from "./JobOfferSettings.vue?vue&type=style&index=0&id=6b597410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b597410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b597410')) {
      api.createRecord('6b597410', component.options)
    } else {
      api.reload('6b597410', component.options)
    }
    module.hot.accept("./JobOfferSettings.vue?vue&type=template&id=6b597410&scoped=true&", function () {
      api.rerender('6b597410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/JobOffers/JobOfferSettings.vue"
export default component.exports